import React from "react";
import moment from "moment";

const CustomEvent = ({ event }) => {
  // console.log({ event });

  if (event.isHold) {
    return (
      <div className="p-2 text-xs h-full w-full bg-yellow-200 border-l-4 border-yellow-500 flex flex-col animate-pulse">
        <span className="font-semibold text-yellow-900">
          ⏳ {event.userName || "Someone"} is booking right now...
        </span>

        <span className="text-[10px] text-yellow-800">
          Expires {moment(event.expiresAt).fromNow()}
        </span>
      </div>
    );
  }

  // ⭐ SAFE SERVICE LIST + MESSAGE
  const services = Array.isArray(event.serviceList)
    ? event.serviceList.map((s) => s?.title || "Untitled")
    : [];

  // const services = (event.serviceList || []).map((s) => s?.title || "Untitled");
  const price = event.price || "—";
  const duration = event.totalTime || "—";
  const phone = event.customerPhone || "—";
  const customer = event.title;
  const staff = event.staffName;
  const photo = event.customerPhoto;
  const message = event.message || ""; // prevent undefined
  const bookingtype = event.bookingtype;
  const initial = customer?.charAt(0)?.toUpperCase() || "?";
  const isPast = moment(event.end).isBefore(moment());
  const isCancelled = event.bookingStatus === "cancelled";

  const isNail = event.type === "nail";
  const isBeauty = event.type === "beauty";

  function hexToRgba(hex, opacity) {
    let bigint = parseInt(hex.replace("#", ""), 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;
    return `rgba(${r},${g},${b},${opacity})`;
  }

  const backgroundColor = isCancelled
    ? "#f87171"
    : isPast
    ? "#d1d5db"
    : isNail
    ? "#bbf7d0"
    : isBeauty
    ? "#dbeafe"
    : "#f3f4f6";

  const borderColor = isCancelled
    ? "#b91c1c"
    : isPast
    ? "#9ca3af"
    : isNail
    ? "#10b981"
    : isBeauty
    ? "#3b82f6"
    : "#9ca3af";

  const labelColor = isNail ? "#065f46" : isBeauty ? "#1e40af" : "#374151";

  const statusLabel = isCancelled
    ? "Cancelled"
    : isPast
    ? "Completed"
    : isNail
    ? "Nail Service"
    : isBeauty
    ? "Beauty Service"
    : "Appointment";

  const tooltipHTML = `
    <div style="
      width: 400px;
      border: 1px solid ${borderColor};
      border-radius: 10px;
      background-color:  ${hexToRgba(backgroundColor, 1)};
      color: #1f2937;
      font-family: sans-serif;
      overflow: hidden;
      margin: 3px;
    ">
      <div style="
        background: ${borderColor};
        color: #fff;
        padding: 10px 14px;
        font-size: 13px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
      ">
        ${moment(event.start).format("h:mm A")} – ${moment(event.end).format(
    "h:mm A"
  )}
        <span>${statusLabel}</span>
      </div>

      <div style="padding: 14px;">
        <div style="display:flex; align-items:center; gap:12px;">

       <div style='width:40px; height:40px; border-radius:50%; background:#334155; display:flex; align-items:center; justify-content:center; font-weight:bold; font-size:16px; color:#facc15;'>
                    ${initial}
                 </div>


          <div style="flex-grow:1;">
            <div style="font-weight:600; text-transform: uppercase">
              ${customer}   
             ${
               bookingtype === "walk-in"
                 ? `<span style="font-size:10px; background:#3b82f6; color:white; padding:2px 6px; border-radius:4px;">Walk-in</span>`
                 : event.isModified
                 ? `<span style="font-size:10px; background:#f59e0b; color:white; padding:2px 6px; border-radius:4px;">Modified</span>`
                 : `<span style="font-size:10px; background:#10b981; color:white; padding:2px 6px; border-radius:4px;">Online</span>`
             }
            </div>
            <div style="font-size:12px; color:#222;">${phone}</div>
          </div>
        </div>

        <div style="margin-top:12px; display:flex; justify-content:space-between; align-items:flex-start;">
          <div style="font-size:13px;">
            ${services.join(", ")}
            <div style="font-size:11px; color:#94a3b8;">${staff} • ${
    duration || "--"
  } min</div>
          </div>
        </div>

        <hr style="margin:12px 0; border-color:#475569;" />

        <div style="display:flex; justify-content:space-between; font-size:12px; color:#222;">
          <span>${services.length} service${
    services.length > 1 ? "s" : ""
  }</span>
        </div>
          ${
            message
              ? `<div style="margin-top:8px; font-size:12px; color:#facc15; background:#334155; padding:6px 10px; border-radius:6px; display:flex; align-items:center; gap:6px;">
           ⚠️ ${message}
         </div>`
              : ""
          }
      </div>
    </div>
  `;

  // TEMP slot (hover only)
  if (event.temp) {
    return (
      <div className="flex items-center justify-start h-full w-full text-yellowlight text-[10px] ml-2">
        {event.title}
      </div>
    );
  }

  // Break event
  if (event.isBreak) {
    return (
      <div className="flex flex-col items-start justify-center h-full w-full text-dry text-[12px] ml-2">
        <p className="uppercase text-red-500">{event.title}</p>
        <div className="mt-1">
          {moment(event.start).format("h:mm A")} –{" "}
          {moment(event.end).format("h:mm A")}
        </div>
      </div>
    );
  }

  //no work event

  // Busy time
  if (event.isBusy) {
    return (
      <div className="flex flex-col items-start justify-center h-full w-full text-dry text-[12px] ml-2 font-semibold">
        <p className="uppercase text-red-500">{event.title}</p>
        <div className="mt-1">
          {moment(event.start).format("h:mm A")} –{" "}
          {moment(event.end).format("h:mm A")}
        </div>
      </div>
    );
  }

  // Main appointment UI
  return (
    <div
      className="p-2 text-sm h-full w-full"
      data-tooltip-id="event-tooltip"
      data-tooltip-html={tooltipHTML}
      style={{
        borderRadius: "6px",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        fontSize: "13px",
        fontFamily: "sans-serif",
      }}
    >
      <div className="font-bold leading-tight flex items-center gap-2">
        <span className="capitalize">{customer}</span>
        <span
          className={`text-[10px] px-2 py-[1px] rounded ${
            bookingtype === "walk-in"
              ? "bg-blue-500 text-white"
              : "bg-green-500 text-white"
          }`}
        >
          {bookingtype === "walk-in" ? "Walk-in" : "Online"}
        </span>
        {event.isModified && (
          <span className="text-[10px] px-2 py-[1px] rounded bg-purple-500 text-white">
            Modified
          </span>
        )}
      </div>
      <div className="text-xs leading-tight">{services.join(", ")}</div>
      <div className="text-[10px] text-gray-700">
        {moment(event.start).format("h:mm A")} –{" "}
        {moment(event.end).format("h:mm A")}
      </div>
      {message.length !== 0 && (
        <div className="text-xs leading-tight">⚠️ {message}</div>
      )}
    </div>
  );
};

export default CustomEvent;
